module.exports = __webpack_public_path__ + "static/media/card.98ba1cea.png";